import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import '@maersk-global/mds-components-core/mc-input';
import '@maersk-global/mds-components-core/mc-select';
import '@maersk-global/mds-components-core/mc-multi-select';
import '@maersk-global/mds-components-core/mc-button';
import { AemsMultilineTagInputComponent } from '../../../shared-components/aems-multiline-tag-input/aems-multiline-tag-input.component';
import { RegexConstants } from '../../../RegexConstants';
import { RepairCodeExclusionFilterForm } from '../../../form-model/repair-code-exclusion-filter.form.model';
import { RepairCodeExclusionService } from '../../../services/repair-code-exclusion.service';
import { firstValueFrom } from 'rxjs';
import { addMissingControls } from '../../../helper/reactive-form-helpers';

@Component({
  selector: 'app-repair-code-exclusion-advanced-filter',
  imports: [CommonModule, ReactiveFormsModule, AemsMultilineTagInputComponent],
  templateUrl: './repair-code-exclusion-advanced-filter.component.html',
  styleUrl: './repair-code-exclusion-advanced-filter.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class RepairCodeExclusionAdvancedFilterComponent implements OnInit {
  @Input({ required: true }) filterForm!: FormGroup<RepairCodeExclusionFilterForm>;

  modeOptions: string[] = [];
  isLoadingModes = false;
  repairCodeRegex = RegexConstants.REPAIR_CODE;

  constructor(
    private readonly service: RepairCodeExclusionService,
    private readonly formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.addControlsToFormGroup();
    this.loadFilterOptions();
  }

  private addControlsToFormGroup(): void {
    addMissingControls(this.filterForm, [
      { name: 'RepairCodeDescriptionList', control: this.formBuilder.control<string[] | null>(null) },
      { name: 'RepairModeList', control: this.formBuilder.control<string[] | null>(null) },
    ]);
  }

  private async loadFilterOptions(): Promise<void> {
    this.isLoadingModes = true;
    try {
      this.modeOptions = await firstValueFrom(this.service.getAllModes());
    } catch {
      this.modeOptions = [];
    } finally {
      this.isLoadingModes = false;
    }
  }

  applyFilters(): void {
    this.filterForm.get('applyFilter')?.setValue(true);
  }

  clearFilters(): void {
    this.filterForm.reset({ RepairCodeDescriptionList: null, RepairModeList: null });
    this.filterForm.get('applyFilter')?.setValue(true);
  }
}
